import { Tween, Easing } from '@tweenjs/tween.js';
import { formatValue, getCurrencySymbol } from '../helper/currencies';
import { EVENTS } from '../../lib/constants';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import HELPERS from '../../lib/globals/helpers/Helpers';
import { TextMetrics } from 'pixi.js';
import { isDesktop } from 'react-device-detect';
class DoubleChanceController {
	constructor(vc, conf) {
		this.config = conf;
		this.currency = getCurrencySymbol(GameConfigs.auth.balance.currency, true);
		this.doubleChanePrice = GameConfigs.config.doublefeatureprice;
		this.currentBet = GameConfigs.currentBet;
		this.reels = GameConfigs.reelComponent;
		this.enabled = false;
		if (vc[this.config.holder].getChildByName(this.config.item, true)) {
			this.parent = vc[this.config.holder].double_wrapper;
			this.vc = vc[this.config.holder].getChildByName(this.config.item, true);
			this.vc.bgText.position.x = 24;
			this.vc.fgText.position.x = 58;
			this.vc.bgimg.position.x = 65;
			this.vc.fgimg.position.x = 18;
			//TODO
			this.parent.parent.handler = this.update.bind(this);
			this.parent.parent.interactive = !GameConfigs.freeSpinLocal.started;
			this.vc.interactive = !GameConfigs.freeSpinLocal.started;
			this.vc.handler = null;
			this.vc.bgimg.cursor = 'pointer';
			this.vc.setActive(GameConfigs.doubleChance);
			this.value = this.parent.DOUBLE_CHANCE_VALUE;
			this.index = GameConfigs.config.bet_steps.indexOf(this.currentBet);

			this.value_currency = this.parent.DOUBLE_CHANCE_CURRENCY;
			this.value_currency.text = this.currency[0];

			this.setValue(this.index);
			//   const textMetric = TextMetrics.measureText(
			//     this.value.text,
			//     this.value.style
			//   );
			this.value_currency.anchor.x = 0;
			this.value_currency.anchor.y = 0.4;
			// this.value_currency.x = this.value.getBounds().width + 28;
			// this.value_currency.y = 38;
			//   this.value_currency.x = textMetric.width - 10;
			//   this.value_currency.y = 0;
			// this.initBorders();
			this.checkLength(this.value, this.value_currency);
			this.value_currency.x = this.value.getBounds().width - 8;
			if (GameConfigs.config.hasdoublefeature) {
				this.addEventListeners();
				window.addEventListener(EVENTS.BONUS_BUY, this, false);
			} else {
				this.parent.parent.alpha = 0.5;
				this.vc.interactive = false;
				this.parent.parent.interactive = false;
				this.init();

				window.addEventListener(EVENTS.BET_UPDATE, this, false);
				this.parent
					.getChildByName(
						window.isMobile || window.isTabled
							? 'double_chance_widget_bg_mobile'
							: 'bg',
						true
					)
					.toggleEnabled(false);
			}
		} else {
			throw new Error(
				'DoubleChanceController failed init ' + JSON.stringify(this.config)
			);
		}
	}

	setValue(index) {
		if (this.currency[1] === 'left') {
			let str =
				this.currency[0] + formatValue(GameConfigs.config.double_steps[index]);
			this.value.text = str;
			this.value_currency.visible = false;
		} else {
			if (GameConfigs.auth.balance.currency === 'GEL') {
				this.value_currency.visible = false;
				this.value.text =
					formatValue(GameConfigs.config.double_steps[index]) +
					this.currency[0];
			} else {
				this.value.text = formatValue(GameConfigs.config.double_steps[index]);
			}
		}
	}
	initBorders() {
		this.border_active_top = this.parent.getChildByName(
			'border_active_top',
			true
		);
		this.border_active_bottom = this.parent.getChildByName(
			'border_active_bottom',
			true
		);
		this.border_passive_top = this.parent.getChildByName(
			'border_passive_top',
			true
		);
		this.border_passive_bottom = this.parent.getChildByName(
			'border_passive_bottom',
			true
		);
		this.changeBoders(GameConfigs.doubleChance);
	}

	changeBoders(double) {
		this.border_passive_top.alpha = double ? 0 : 1;
		this.border_passive_bottom.alpha = double ? 0 : 1;
		this.border_active_top.alpha = double ? 1 : 0;
		this.border_active_bottom.alpha = double ? 1 : 0;
	}

	addEventListeners() {
		window.addEventListener(EVENTS.BET_UPDATE, this, false);
		window.addEventListener(EVENTS.SERVER_MSG, this, false);
		window.addEventListener(EVENTS.ERROR_PAGE, this, false);
		window.addEventListener(EVENTS.SETTINGS_UPDATE, this, false);
		window.addEventListener(EVENTS.MODAL, this, false);
		window.addEventListener(EVENTS.DOUBLE_CHANCE, this, false);
		window.addEventListener(EVENTS.BONUS_ROUND_STATE, this, false);
		window.addEventListener(EVENTS.IS_DISABLED, this, false);
		if (
			GameConfigs.settings.keyboard_shortcuts &&
			!window.isMobile &&
			!window.isTablet
		) {
			this.enabled = true;
			window.addEventListener('keydown', this, false);
		}
	}

	handleEvent(evt) {
		switch (evt.type) {
			case EVENTS.IS_DISABLED:
				if (evt.detail.disable.double_widget) {
					this.vc.interactive = false;
					this.parent.parent.interactive = false;
				} else {
					this.vc.interactive = true;
					this.parent.parent.interactive = true;
				}
				break;
			case EVENTS.BET_UPDATE:
				this.currentBet = evt.detail.betAmount;
				this.index = GameConfigs.config.bet_steps.indexOf(evt.detail.betAmount);
				this.setValue(this.index);
				this.checkLength(this.value, this.value_currency);

				break;
			case EVENTS.BONUS_BUY:
				if (evt.detail.bonus) {
					this.removeListeners();
				} else {
					this.addEventListeners();
				}
				break;

			case EVENTS.BONUS_ROUND_STATE:
				if (evt.detail.state === 'started') {
					window.removeEventListener(EVENTS.BONUS_BUY, this, false);
					window.removeEventListener(EVENTS.BONUS_ROUND_STATE, this, false);
				}
				break;
			case EVENTS.ERROR_PAGE:
				if (evt.detail.error) {
					this.removeListeners();
					window.removeEventListener(EVENTS.BONUS_BUY, this, false);
					window.removeEventListener(EVENTS.BONUS_ROUND_STATE, this, false);
				}
				break;

			case EVENTS.DOUBLE_CHANCE:
				// this.changeBoders(evt.detail.doubleChance);

				if (!evt.detail.doubleChance) {
					this.vc.active = evt.detail.doubleChance;
					GameConfigs.doubleChance = evt.detail.doubleChance;
					// this.animateDisable()
					this.init();
				}
				break;
			case 'keydown':
				if (evt.keyCode === 68) {
					if (!this.parent.parent.interactive) return;
					this.update();
				}
				break;
			case EVENTS.SETTINGS_UPDATE:
				if (window.isMobile || window.isTablet) return;
				if (evt.detail.data.keyboard_shortcuts === undefined) return;
				if (evt.detail.data.keyboard_shortcuts) {
					if (this.enabled) return;
					this.enabled = true;
					window.addEventListener('keydown', this, false);
				} else {
					this.enabled = false;
					window.removeEventListener('keydown', this, false);
				}
				break;
			case EVENTS.MODAL:
				if (!window.isMobile && !window.isTablet) return;
				if (
					evt.detail.modal === 'settings' ||
					evt.detail.modal === 'quest' ||
					evt.detail.modal === 'quest_claim' ||
					GameConfigs.bonusBuy
				) {
					this.parent.parent.interactive = false;
				} else this.parent.parent.interactive = true;
				break;
			default:
				break;
		}
	}

	init() {
		this.vc.bg.alpha = this.vc.active ? 1 : 0;
		this.vc.bgimg.alpha = this.vc.active ? 1 : 0;
		this.vc.fg.alpha = this.vc.active ? 0 : 1;
		this.vc.fgimg.alpha = this.vc.active ? 0 : 1;
	}

	resize(w, h) {
		this.checkLength(this.value);
		if (window.isMobile || window.isTablet) {
			if (w < h) {
				this.vc.position.x = 230;
				this.vc.position.y = 50;
			} else {
				this.vc.position.x = 30;
				this.vc.position.y = 134;
			}
			this.vc.position.x = 230;
			this.vc.position.y = 50;
		}
	}

	update() {
		if (
			!GameConfigs.freeSpin?.isActive &&
			!GameConfigs.bonusBuy &&
			!this.reels.rotating &&
			!GameConfigs.autospin.isAutoOn &&
			!GameConfigs.quest_claim.step &&
			!GameConfigs.isFreeSpin &&
			!GameConfigs.quest_is_active
		) {
			if (this.vc.active) {
				window.sm.play({ name: 'double_chance_off_sfx' });
			} else {
				window.sm.play({ name: 'double_chance_on_sfx' });
			}
			this.vc.active = !this.vc.active;
			GameConfigs.doubleChance = this.vc.active;
			this.init();
			HELPERS.dispatchCustomEvent(EVENTS.DOUBLE_CHANCE, {
				doubleChance: this.vc.active
			});
		} else {
			this.animateDisable();
		}
	}

	animateDisable() {
		if (this.tween) {
			this.tween = null;
		} else {
			window.sm.play({ name: 'error_sfx' });
			this.tween = new Tween(this.parent)
				.to({ x: 5 }, 10)
				.yoyo(true)
				.repeat(5)
				.easing(Easing.Linear.None)
				.start();
		}
	}
	checkLength(value, currency) {
		if (value.text.length >= 9) {
			value.text = value.text.slice(0, 8) + '...';
			value.style.fontSize = 34;
			this.value_currency.y = 26;
			const textMetric = TextMetrics.measureText(value.text, value.style);
			this.value_currency.x = textMetric.width + 28;
			this.value_currency.y = isDesktop
				? textMetric.height
				: textMetric.height - 10;
		} else {
			value.style.fontSize = 42;
			this.setValue(this.index);
			const textMetric = TextMetrics.measureText(value.text, value.style);
			this.value_currency.y = isDesktop
				? textMetric.height
				: textMetric.height - 10;
			this.value_currency.x = textMetric.width + 28;
		}
	}
	removeListeners() {
		this.vc.interactive = false;
		this.parent.parent.interactive = false;
		this.vc.bgimg.cursor = 'default';
		window.removeEventListener(EVENTS.SERVER_MSG, this, false);
		window.removeEventListener(EVENTS.BET_UPDATE, this, false);
		window.removeEventListener(EVENTS.ERROR_PAGE, this, false);
		window.removeEventListener(EVENTS.SETTINGS_UPDATE, this, false);
		window.removeEventListener(EVENTS.MODAL, this, false);
		window.removeEventListener(EVENTS.DOUBLE_CHANCE, this, false);
		window.removeEventListener('keydown', this, false);
	}
}

export default DoubleChanceController;
